// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "mail." + chunkId + "." + {"66":"53105f97ecf8e30bf6e5","240":"c529b2b0c248d61bb9ee","471":"5ddda6d4a08c14c3d5f0","862":"458cd8a2dcb551c87e4a","932":"2df19b013296cea01792"}[chunkId] + ".js";
};